module.exports = __webpack_public_path__ + "static/media/59.100d4cc3.jpg";